const assignmentEn = {
    assignment: require('../../lang/en/assignment/Assignment').default,
};

export default assignmentEn;
